import i18next from 'i18next';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchClientPatients } from '@/api/patients/patientsApi';
import type { PatientSummary } from '@/api/patients/patientsApi.types';
import { buildClientPatientsQueryKey } from '@/constants/queryKeys';

export function useClientPatientsQuery(
  clientId: string
): UseQueryResult<PatientSummary[], Error> {
  return useQuery({
    queryKey: [...buildClientPatientsQueryKey(clientId), i18next.language],
    queryFn: function loadPatients() {
      return fetchClientPatients(clientId);
    },
  });
}
